import Solutions from 'Components/Solutions/Solutions';

export default Solutions;
